export class ShifttypeType {
    id: number;
    name: string;
}
